import React, { memo, useCallback, useState } from 'react'
import { useStyles } from './styles'
import { Grid } from '@material-ui/core'
import { Button } from 'src/components/Button'
import { BodyProps } from '../..'
import { Loading } from 'src/components/Loading'
import { AssignmentOutlined, FilterList } from '@material-ui/icons'

interface CustomButtonProps {
  onClickItem?: (item: any) => void
  loadMore: () => void
  cardComponent?: Function
  setCurrentPage: Function
  body: Array<BodyProps>
  pages: number
  currentPage: number
  filterIsActive?: boolean
  isFetchingNextPage?: boolean
  isLoading?: boolean
  totalItens?: number
  isError?: boolean
  refetch?: () => void
}

const CardViewModeComponent: React.FC<CustomButtonProps> = ({
  onClickItem,
  body,
  pages,
  currentPage,
  cardComponent,
  filterIsActive = false,
  loadMore,
  isFetchingNextPage,
  isLoading: isInitialLoading = false,
  totalItens,
  isError = false,
  refetch
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const styles = useStyles()

  const isFilteredEmpty = filterIsActive && !body.length

  const handleLoadMore = useCallback(() => {
    if (isFetchingNextPage) return

    setIsLoading(true)
    setTimeout(() => {
      loadMore()
      setIsLoading(false)
    }, 1000)
  }, [loadMore, isFetchingNextPage])

  if (isError) {
    return <Loading isError={isError} refetch={refetch} />
  }

  if (isInitialLoading) {
    return <Loading />
  }

  return (
    <div className={styles.cardViewModeContainer}>
      <div>
        <Grid container spacing={1}>
          {body.length ? (
            body.map((item, index) => (
              <Grid key={index} item xs={12} sm={4} md={2}>
                {cardComponent && <div onClick={() => onClickItem && onClickItem(item)}>{cardComponent(item)}</div>}
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <div className={styles.emptyStateContainer}>
                <div className={styles.emptyStateIcon}>
                  {isFilteredEmpty ? (
                    <FilterList style={{ fontSize: 64, opacity: 0.5, transform: 'rotate(180deg)' }} />
                  ) : (
                    <AssignmentOutlined style={{ fontSize: 64, opacity: 0.5 }} />
                  )}
                </div>
                <div className={styles.emptyStateContent}>
                  {isFilteredEmpty ? (
                    <>
                      <h3 className={styles.emptyStateTitle}>Nenhum resultado encontrado</h3>
                      <p className={styles.emptyStateDescription}>Sua pesquisa não retornou resultados.</p>
                      <p className={styles.emptyStateSuggestion}>
                        Tente ajustar ou limpar os filtros para ver mais registros.
                      </p>
                    </>
                  ) : (
                    <>
                      <h3 className={styles.emptyStateTitle}>Nenhum registro encontrado</h3>
                      <p className={styles.emptyStateDescription}>Não há registros para exibir.</p>
                    </>
                  )}
                </div>
              </div>
            </Grid>
          )}
        </Grid>
        {body.length > 0 && pages > 1 && currentPage < pages - 1 && (
          <div className={styles.loadMoreContainer}>
            {isFetchingNextPage || isLoading ? (
              <div className={styles.loadingContainer}>
                <Loading className={styles.loading} />
              </div>
            ) : (
              <Button
                style={{ textTransform: 'capitalize', fontWeight: 600 }}
                className={`${styles.buttonOutlined} ${styles.buttonWrapper} ${styles.lodingMoreButton}`}
                onClick={handleLoadMore}
                disabled={isFetchingNextPage}
              >
                Carregar mais
              </Button>
            )}
          </div>
        )}
      </div>
      <div className={styles.totalItemsContainer}>{totalItens && <p>{totalItens} Registros encontrados</p>}</div>
    </div>
  )
}

export const CardViewMode = memo(CardViewModeComponent)
